import { Header, Section } from "../../components/layout";
import { Grid } from "../../components/util";
import { OnboardingUnverified } from "../../components/content";
import { brand } from "../../config/brand";

const Unverified = () => {
  return (
    <Grid container>
      <Header
        title={`Getting started with ${brand.shortName}`}
        type="article"
      ></Header>
      <Section>
        <OnboardingUnverified />
      </Section>
    </Grid>
  );
};
export default Unverified;
